import useHttpProvider from "@/common/hooks/use-http";
import { useIsMobile } from "@/common/hooks/use-mobile";
import { Button } from "@/components/ui/button";
import { Winner } from "@/features/winners/models/winner";
import * as WinnersService from "@/features/winners/services/winners";
import { useEffect, useState } from "react";
import PreviousPrize from "../components/previous-prize";

function PreviousPrizes() {
	const isMobile = useIsMobile();
	const { http } = useHttpProvider();

	const [previousWinners, setPreviousWinners] = useState<Winner[]>([]);
	const [visibleCount, setVisibleCount] = useState(4);

	const visiblePrizes = isMobile
		? previousWinners.slice(0, visibleCount)
		: previousWinners;

	const getPreviousWinners = async () => {
		try {
			const winners = await WinnersService.getPreviousWinners(http);
			setPreviousWinners(winners);
		} catch (error) {
			console.error("Error fetching previous winners:", error);
		}
	};

	const handleLoadMore = () => {
		setVisibleCount((prev) => prev + 4);
	};

	useEffect(() => {
		getPreviousWinners();
	}, []);

	if (previousWinners.length === 0) {
		return null;
	}

	return (
		<div className="relative flex flex-col gap-12 px-4 py-16 text-center md:px-37 md:py-50 md:pt-70">
			<div className="flex flex-col gap-4">
				<span className="web-heading-h2">
					Previous{" "}
					<span
						style={{
							background:
								"linear-gradient(161deg, #0FF1E5 3.9%, #0DAAEC 33.24%, #0823F8 72.3%, #000D74 116.02%)",
							WebkitBackgroundClip: "text",
							backgroundClip: "text",
							WebkitTextFillColor: "transparent",
						}}
					>
						Prizes
					</span>
				</span>
				<span className="web-body-b1 text-gray-700">
					We are just getting started 🔥
				</span>
			</div>

			<div className="w-full md:overflow-x-auto">
				<div className="flex-row gap-8 max-sm:grid max-sm:grid-cols-2 max-sm:flex-wrap md:flex md:min-h-137 md:gap-4">
					{visiblePrizes.map((previousWinner, index) => (
						<PreviousPrize key={index} winner={previousWinner} />
					))}
				</div>
			</div>

			{isMobile && visibleCount < previousWinners.length && (
				<div className="flex w-full flex-row justify-center">
					<Button
						onClick={handleLoadMore}
						variant={"secondary"}
						className="w-50"
					>
						Load More
					</Button>
				</div>
			)}
		</div>
	);
}

export default PreviousPrizes;
